import PermissionEdit from './PermissionEdit';
import { connect } from 'react-redux';
import {
  editPermission,
  fetchPermission
} from '../../../actions/permission_actions';
import { fetchRoles } from '../../../actions/role_actions';
import { bindActionCreators } from 'redux';

function mapStateToProps(state) {
  return {
    permission: state.permissions.permission,
    roles: state.role.roles,
    isSubmitting: state.requestState.requestSavePermissionSend,
    serverErrors: state.requestState.requestErrorsOnSavePermission
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchRoles: bindActionCreators(fetchRoles, dispatch),
    editPermission: bindActionCreators(editPermission, dispatch),
    fetchPermission: bindActionCreators(fetchPermission, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PermissionEdit);
